module.exports = __webpack_public_path__ + "static/media/expand-arrow.75f28518.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expand-arrow.svg
// module id = 1049
// module chunks = 1